import * as XLSX from 'sheetjs-style';

export type ItemAmazon = { sku: string; asin: string };
export const MAX_ITENS_AMAZON = 500;

const normalizarCabecalho = (valor: unknown) => String(valor ?? '').trim().normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');

export const lerPlanilhaAmazon = (dados: ArrayBuffer): ItemAmazon[] => {
  const workbook = XLSX.read(dados, { type: 'array' });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  if (!sheet) throw new Error('A planilha não contém uma aba com dados.');
  const linhas = XLSX.utils.sheet_to_json<any[]>(sheet, { header: 1, raw: false, defval: '' });
  if (linhas.length < 2) throw new Error('Inclua um cabeçalho SKU, ASIN e pelo menos uma linha de produto.');
  const cabecalho = linhas[0].map(normalizarCabecalho);
  const colunaSku = cabecalho.indexOf('SKU');
  const colunaAsin = cabecalho.indexOf('ASIN');
  if (colunaSku < 0 || colunaAsin < 0) throw new Error('A primeira linha precisa conter as colunas SKU e ASIN.');

  const itens: ItemAmazon[] = [];
  const skuParaAsin = new Map<string, string>();
  const asinParaSku = new Map<string, string>();
  for (let indice = 1; indice < linhas.length; indice++) {
    const linha = linhas[indice];
    const sku = String(linha[colunaSku] ?? '').trim();
    const asin = String(linha[colunaAsin] ?? '').trim().toUpperCase();
    if (!sku && !asin) continue;
    const numero = indice + 1;
    if (!sku || sku.length > 100 || !/^[A-Z0-9]{10}$/.test(asin)) {
      throw new Error(`Linha ${numero}: informe um SKU e um ASIN de 10 letras ou números.`);
    }
    const chaveSku = sku.toUpperCase();
    if (skuParaAsin.has(chaveSku) && skuParaAsin.get(chaveSku) !== asin) {
      throw new Error(`Linha ${numero}: este SKU já está associado a outro ASIN.`);
    }
    if (asinParaSku.has(asin) && asinParaSku.get(asin) !== chaveSku) {
      throw new Error(`Linha ${numero}: este ASIN já está associado a outro SKU.`);
    }
    if (!skuParaAsin.has(chaveSku)) itens.push({ sku, asin });
    skuParaAsin.set(chaveSku, asin);
    asinParaSku.set(asin, chaveSku);
    if (itens.length > MAX_ITENS_AMAZON) throw new Error(`Limite de ${MAX_ITENS_AMAZON} produtos por arquivo.`);
  }
  if (!itens.length) throw new Error('Nenhuma linha de produto foi encontrada.');
  return itens;
};
